import { render, staticRenderFns } from "./CurrentWipStockAdjust.vue?vue&type=template&id=51927c06&"
import script from "./CurrentWipStockAdjust.vue?vue&type=script&lang=js&"
export * from "./CurrentWipStockAdjust.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports